import axios from 'axios';
import moment from 'moment';
// socket.js
import io from 'socket.io-client';
// const socket = io("https://websocketlinux2023.ihs-w.com",{
// const socket = io("https://iconntestlinux2023.ihs-w.com",{
// // const socket = io("https://iconntest.hrd-s.com",{ // old iconn link - UPDATED 20260603
//     transports: ["websocket"]
// });

    export function newBossRegister(bossCodes){
        if(bossCodes){
            try {
                const response = axios.post(`api/zumen_type_multi`, {
                    boss : bossCodes
                });
                if (response.data) {
                    return response.data;
                }
            } catch (error) {
                console.error('Error fetching zumen type:', error);
                throw error; // Rethrow the error to be caught by the calling code
            }
        }
    }

    export async function getAllBossCode(
        revisionSelection,
        cadRequestBasicInformation,
        cadRequestRevisionContent,
        cadPreviousData,
        ph6User
    ){
        let bossCodes = await getAllBossCodeDoc(
            revisionSelection,
            cadRequestBasicInformation,
            cadRequestRevisionContent,
            cadPreviousData,
            ph6User);

        if(bossCodes){
            
            // console.log(cadRequestRevisionContent,'cadRequestRevisionContent') <-- this will get the index data
            try {
                if(cadRequestRevisionContent.isBossChecked == 1){
                    bossCodes = bossCodes.map((r) => {
                        if(r.boss_code != '357') r.boss_code = r.boss_code + 'NB';
                        return r;
                    })
                }

                const response = await axios.post("api/getDocArr", {
                    boss : bossCodes,
                    basic: cadRequestBasicInformation,
                    cad: cadRequestRevisionContent,
                });
                console.log(response.data, 'res')

                if (response.data) {
                    return response.data;
                }
            } catch (error) {
                console.error('Error fetching zumen type:', error);
                throw error; // Rethrow the error to be caught by the calling code
            }
        }
    }

    export function getAllBossCodeDoc(
                    revisionSelection,
                    cadRequestBasicInformation,
                    cadRequestRevisionContent,
                    cadPreviousData,
                    ph6User                        
                ){

        let bossCode = [
            {
                boss_code : '357',
                boss_remarks : null,
                pers_hp_code : null,
            }
        ]
        let code006 = /^(0009999|00100|P|SA|TF|TJ|HRD|TEST|HA|MB)/;
        let codeP25 = /^(0009999|00100|P|SA)/;
        let codeS93 = /^(P|TF)/;
        let codeP76 = ['003','004','005','852']
        let codeP79 = ['003']
        let code127 = ["003"]
        let code201 = ["201"]
        let special = ["852", "042", "005", "P33"]
        let withHPSP = ["P33"]
        let code80 = /^(QL|QB|981|0008888)/;
        // let tempBoss = ['357'];


        // SECTION : BOSS CODE : F80
        // NOTE    : If the customer code or construction code start with specific letter or number
        if (code80.test(cadRequestBasicInformation.construction_code) && cadRequestRevisionContent.site_layout != null) {
            bossCode.push({
                boss_code: 'F80',
                boss_remarks: null,
                pers_hp_code: null,
            });
        }

        // if(!revisionSelection == '5'){
        // SECTION : BOSS CODE : 003
        // NOTE    : Main boss_code
        if(cadRequestRevisionContent.revision_type == '1' || cadRequestRevisionContent.revision_type == '2' || cadRequestRevisionContent.revision_type == '3' || cadRequestRevisionContent.revision_type == '4'
        || (cadRequestRevisionContent.revision_type == '8' && (cadRequestRevisionContent.isHrdCpn == 0 || cadRequestRevisionContent.isHrdCpn == null)) || (cadRequestRevisionContent.revision_type == '9' && (cadRequestRevisionContent.isHrdCpn == 0 || cadRequestRevisionContent.isHrdCpn == null))
        || (cadRequestRevisionContent.revision_type == '5' && cadRequestRevisionContent.gravity_type == '5A' || cadRequestRevisionContent.gravity_type == '5B' || cadRequestRevisionContent.gravity_type == '5C' || cadRequestRevisionContent.gravity_type == '5Z') && cadRequestRevisionContent.revision_type !== '7'){
            bossCode.push(
                    {
                        boss_code : '003',
                        boss_remarks : null,
                        pers_hp_code : null,
                    },
                    // {
                    //     boss_code : '127',
                    //     boss_remarks : null,
                    //     pers_hp_code : null,
                    // },
                );
        // }
        // SECTION : BOSS CODE : 006
        // NOTE    : No need to register if control code is starts with "0009999","00100","P(PA PB PCPSH PSM PS3 PLK PLH PL)","SA","TF","TJ","HRD","TEST","HA","MB".        
        if(!code006.test(cadRequestBasicInformation.construction_code) && cadRequestRevisionContent.revision_type !== '7'){
            bossCode.push({
                        boss_code : '006',
                        boss_remarks : null,
                        pers_hp_code : null,
                    });
        }

        // if(cadRequestRevisionContent.site_layout != null){
        //     bossCode.push({
        //         boss_code : '003',
        //         boss_remarks : null,
        //         pers_hp_code : null,
        //     });
        //     bossCode.push({
        //         boss_code : '005',
        //         boss_remarks : null,
        //         pers_hp_code : null,
        //     });
        // }

        // SECTION : BOSS CODE : P76
        // NOTE    : If plan is iCAD. In the future if 100% implement iCAD. Automatic register already.
        // if(cadRequestBasicInformation.house_type_category == 2 && 
        //     (cadRequestRevisionContent.request_type == "新規(A)" || cadRequestRevisionContent.request_type == "変更(C)" || cadRequestRevisionContent.request_type == "追変(TH)")){
        //     bossCode.push({
        //                 boss_code : 'P76',
        //                 boss_remarks : null,
        // }
        }

            
        // SECTION : BOSS CODE : S93
        // NOTE    : If control code starts with " P" or "TF"
        if(codeS93.test(cadRequestBasicInformation.construction_code)){
            bossCode.push({
                        boss_code : 'S93',
                        boss_remarks : null,
                        pers_hp_code : null,
                    });
        }

        // SECTION : BOSS CODE : P79
        // NOTE    : If plan is FP, need to register this boss_code.
        let bossFP = bossCode.some(value => codeP79.includes(value.boss_code));
            if( cadRequestRevisionContent.gravity === "1" || cadRequestRevisionContent.gravity === "2" || cadRequestRevisionContent.gravity === "3" ||
                cadRequestRevisionContent.final_plan || cadRequestRevisionContent.request_type === "変更(C)" || cadRequestRevisionContent.request_type === "追変(TH)" ){
                if(bossFP){
                    bossCode.push({
                        boss_code : 'P79',
                        boss_remarks : null,
                        pers_hp_code : null,
                    });
                }
                
            // if(cadRequestRevisionContent.final_plan){
            //     if(bossFP){
            //         bossCode.push({
            //             boss_code : 'P79',
            //             boss_remarks : null,
            //             pers_hp_code : null,
            //         });
            //     }
        
            // bossCode.push({
            //             boss_code : 'P79',
            //             boss_remarks : null,
            //             pers_hp_code : null,
            //         });
            if(cadRequestRevisionContent.final_plan == '2' || cadRequestRevisionContent.final_plan == '3'){
                bossCode.push({
                    boss_code : '128',
                    boss_remarks : null,
                    pers_hp_code : null,
                });
            }
        }


        // SECTION : BOSS CODE : P76
        // NOTE    : If there is any of the boss code 003,004,005,852 is selected, always register P76 boss code.
        //           Need to auto register to all wakugumi plans. For jikugumi, no need for now(In the future pa
        //           if all plans will be encoded in icad), alias.waku is for HOME.vue
        let isBossCodeSelected = bossCode.some(value => codeP76.includes(value));
        let getPreviousiCad = [];
        if(cadPreviousData != null) { // <- if with previous plan and already registered P76, it will not registered to latest below the condition
            getPreviousiCad = cadPreviousData.xml_icad.filter((res) => {
                return res.boss_code === 'P76';
            });
        }
        if((cadRequestRevisionContent.house_type_category == 2 || cadRequestRevisionContent.alias == 'waku' || isBossCodeSelected) && cadRequestRevisionContent.revision_type !== '7' ||
            (!getPreviousiCad.length && !( // <- Etong condition na to yung sa previous P76 eyyy napaka angas
                (cadRequestRevisionContent.revision_type === '8' && (cadRequestRevisionContent.isHrdCpn === 1 || cadRequestRevisionContent.isHrdCpn === null)) ||
                (cadRequestRevisionContent.revision_type === '9' && (cadRequestRevisionContent.isHrdCpn === 1 || cadRequestRevisionContent.isHrdCpn === null)) ||
                (cadRequestRevisionContent.revision_type === '5' && cadRequestRevisionContent.gravity_type === '5D') || cadRequestRevisionContent.revision_type === '6'
            ))
        ){
            bossCode.push({
                boss_code : 'P76',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }


        let hasBoss003 = bossCode.some(value => code127.includes(value.boss_code));
        let hasBossP76 = bossCode.some(value => codeP76.includes(value.boss_code));
        let hasFinalPlan = !!cadRequestRevisionContent.final_plan;

        let isNotExcludedForPH6 = !(
            (cadRequestRevisionContent.revision_type === '8' && (cadRequestRevisionContent.isHrdCpn === 1 || cadRequestRevisionContent.isHrdCpn === null)) ||
            (cadRequestRevisionContent.revision_type === '9' && (cadRequestRevisionContent.isHrdCpn === 1 || cadRequestRevisionContent.isHrdCpn === null)) ||
            (cadRequestRevisionContent.revision_type === '5' && cadRequestRevisionContent.gravity_type === '5D') || cadRequestRevisionContent.revision_type === '6'
        );

        let hasPh6User = !!ph6User;


        if (hasBoss003 && hasBossP76 && hasFinalPlan && isNotExcludedForPH6 && hasPh6User) {
            console.log('✅ All PH6 conditions met! Pushing PH6 to bossCode.');
            bossCode.push({
                boss_code : 'PH6',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }    

        // SECTION : BOSS CODE : 
        // NOTE    : No registration of boss code but need to have mark in database as reference for phase 2.
        // if(cadRequestRevisionContent.design_contract){
        //     bossCode.push({
        //         boss_code : null,
        //         boss_remarks : '設計受託契約',
        //         pers_hp_code : null,
        //     });
        // }

        // SECTION : BOSS CODE : 076
        // NOTE    : Main boss code
        if(cadRequestRevisionContent.calculation_basis){
            bossCode.push({
                boss_code : '076',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }
        
        // SECTION : BOSS CODE : SITE
        // NOTE    : No need to reflect to BOSS
        if(cadRequestRevisionContent.site_layout){
            bossCode.push(
                // {
                //     boss_code : 'SITE',
                //     boss_remarks : null,
                //     pers_hp_code : null,
                // },
                {
                    boss_code : '004',
                    boss_remarks : null,
                    pers_hp_code : null,
                });

            // SECTION : BOSS CODE : SITEM
            // NOTE : No need to reflect to BOSS. If select "手入カ" button. - SITEM
            // if(cadRequestRevisionContent.site_layout == '手入力M'){
            //     bossCode.push({
            //             boss_code : 'SITEM',
            //             boss_remarks : null,
            //             pers_hp_code : null,
            //         });
            // }
            // SECTION : BOSS CODE : P25
            // NOTE : No need to register if control code is starts with "0009999" or "00100" or "P" or "SA"
            if(!codeP25.test(cadRequestBasicInformation.construction_code)){
                bossCode.push({
                        boss_code : 'P25',
                        boss_remarks : null,
                        pers_hp_code : null,
                    });
            }
            // SECTION : BOSS CODE : P76
            // NOTE : If selected "CAD図面番号の変更なし" in revision number, no need to register this boss code.
            // if(revisionSelection != '5'){
            //     bossCode.push({
            //                 boss_code : 'P76',
            //                 boss_remarks : null,
            //             });
            // }
            // console.log(
            //     cadRequestRevisionContent.site_layout_option,cadRequestRevisionContent.site_layout

            // )
            // if(cadRequestRevisionContent.boss_sending != '1'){
                // SECTION : BOSS CODE : 298, 813
                // NOTE : If selected "現況図のみ" , need to register this boss code.
                if(cadRequestRevisionContent.site_layout == "新規データN"){
                    //  添付ファイル参照（現況図のみ）
                    if(cadRequestRevisionContent.site_layout_option == 'option2'){ 
                        bossCode.push({
                            boss_code : '298',
                            boss_remarks : null,
                            pers_hp_code : null,
                        },
                        {
                            boss_code : '813',
                            boss_remarks : null,
                            pers_hp_code : null,
                        });
                        //  添付ファイル参照（現況図及び敷地断面図）
                    }else if(cadRequestRevisionContent.site_layout_option == 'option3'){ 
                        bossCode.push({
                            boss_code : '298',
                            boss_remarks : null,
                            pers_hp_code : null,
                        },
                        {
                            boss_code : '813',
                            boss_remarks : null,
                            pers_hp_code : null,
                        },{
                            boss_code : '966',
                            boss_remarks : null,
                            pers_hp_code : null,
                        },
                        {
                            boss_code : 'J13',
                            boss_remarks : null,
                            pers_hp_code : null,
                        });
                    }

                }
                // SECTION : BOSS CODE : 966, J13
                // NOTE : If selected "現況図と敷地断面図・直交図" , need to register this boss code.
                // else if(cadRequestRevisionContent.site_layout == "前回ベースP"){
                //     bossCode.push({
                //             boss_code : '966',
                //             boss_remarks : null,
                //             pers_hp_code : null,
                //         },
                //         {
                //             boss_code : 'J13',
                //             boss_remarks : null,
                //             pers_hp_code : null,
                //         });
                // }
            // }
        }

        // if(cadRequestRevisionContent.specs_irai){
        //     bossCode.push({
        //         boss_code : '',
        //         boss_remarks : cadRequestRevisionContent.specs_irai.sash_type,
        //         pers_hp_code : null,
        //     },
        //     {
        //         boss_code : '',
        //         boss_remarks : cadRequestRevisionContent.specs_irai.specs,
        //         pers_hp_code : null,
        //     });
        //     if(cadRequestRevisionContent.specs_irai.accessories.length > 0){
        //         cadRequestRevisionContent.specs_irai.accessories.forEach((el) => {
        //             bossCode.push({
        //                 boss_code : '',
        //                 boss_remarks : el.value,
        //                 pers_hp_code : null,
        //             });
        //         })
        //     }
        // }

        // SECTION : BOSS CODE : P29
        // NOTE    : Main boss_code
        if(cadRequestRevisionContent.dxf_data_request){
            bossCode.push({
                boss_code : 'P29',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }

        if(cadRequestRevisionContent.dxf_data_request || cadRequestRevisionContent.site_layout){
            bossCode.push(
                {
                    boss_code : 'SITE',
                    boss_remarks : null,
                    pers_hp_code : null,
                },
            )

            if(cadRequestRevisionContent.final_plan){
                bossCode.push(
                    {
                        boss_code : 'PG7',
                        boss_remarks : null,
                        pers_hp_code : null,
                    },
                )
            }
        }

        // NOTE: If both box has no date or both blank AND HP IS WITH DATA, it means that it is HPCOM
        if(!cadRequestBasicInformation.provisional_contract_date && !cadRequestBasicInformation.contract_date && cadRequestRevisionContent.hp.length > 0){

            // --------OLD-------
            // bossCode.push({
            //     boss_code : '042',
            //     boss_remarks : 'HPCOM' ,
            //     pers_hp_code : 'HPCOM',
            // });

            // -------NEW (SSD25-0407783-2121)--------
            if(cadRequestRevisionContent.color_perspective){
                let rem = null;

                cadRequestRevisionContent.color_perspective.forEach((element, index) => {
                    if(cadRequestRevisionContent.color_perspective.length <= 1){
                        rem = 'PR';
                    }else{
                        rem = 'PR' + (index+1);
                    }
                    bossCode.push({
                        boss_code : '005',
                        boss_remarks : rem ,
                        pers_hp_code : rem,
                    });
                });
            }
            // SECTION : BOSS CODE : 042
            // NOTE    : Can create multiple HRDID depends on number of pattern request.
            // NOTE    : Depends on how many pattern for each case. At yung i-fifilter nya lang ay yung may value na 1 ang request_color_info
            if(cadRequestRevisionContent.hp){
                const hpColorInfo = cadRequestRevisionContent.hp.filter(element => element.is_request_color_info === 1);
                const zeroHpColorInfo = cadRequestRevisionContent.hp.filter(element => element.is_request_color_info === 0);
                if(hpColorInfo.length != 0 && zeroHpColorInfo.length != 0) {
                    hpColorInfo.forEach((element, index) => {
                        let rem;
                        if(hpColorInfo.length <= 1){
                            rem = 'HPBEV';
                        } else {
                            rem = 'HPBEV' + (index + 1);
                        }
                        bossCode.push({
                            boss_code : '042',
                            boss_remarks : rem,
                            pers_hp_code : rem,
                        });
                    });
                } else if(hpColorInfo.length != 0) {
                    hpColorInfo.forEach((element, index) => {
                        let rem;
                        if(hpColorInfo.length <= 1){
                            rem = 'HPBEV';
                        } else {
                            rem = 'HPBEV' + (index + 1);
                        }
                        bossCode.push({
                            boss_code : '042',
                            boss_remarks : rem,
                            pers_hp_code : rem,
                        });
                    });
                } else if(zeroHpColorInfo.length != 0){
                    zeroHpColorInfo.forEach((element, index) => {
                        let rem;
                        if(zeroHpColorInfo.length <= 1){
                            rem = 'HPBEV';
                        } else {
                            rem = 'HPBEV' + (index + 1);
                        }
                        bossCode.push({
                            boss_code : '042',
                            boss_remarks : rem,
                            pers_hp_code : rem,
                        });
                    });
                }
            }
            
        } else{
            // SECTION : BOSS CODE : 005
            // NOTE    : Can create multiple HRDID depends on number of pattern request.
            // NOTE    : Depends on how many pattern for each case.
            if(cadRequestRevisionContent.color_perspective){
                let rem = null;

                cadRequestRevisionContent.color_perspective.forEach((element, index) => {
                    if(cadRequestRevisionContent.color_perspective.length <= 1){
                        rem = 'PR';
                    }else{
                        rem = 'PR' + (index+1);
                    }
                    bossCode.push({
                        boss_code : '005',
                        boss_remarks : rem ,
                        pers_hp_code : rem,
                    });
                });
            }
            // test
            // SECTION : BOSS CODE : 042
            // NOTE    : Can create multiple HRDID depends on number of pattern request.
            // NOTE    : Depends on how many pattern for each case. At yung i-fifilter nya lang ay yung may value na 1 ang request_color_info
            if(cadRequestRevisionContent.hp){
                const hpColorInfo = cadRequestRevisionContent.hp.filter(element => element.is_request_color_info === 1);
                const zeroHpColorInfo = cadRequestRevisionContent.hp.filter(element => element.is_request_color_info === 0);
                // console.log(hpColorInfo,'hpColor')
                // console.log(zeroHpColorInfo,'zeroHpColorInfo')
                if(hpColorInfo.length != 0 && zeroHpColorInfo.length != 0) {
                    hpColorInfo.forEach((element, index) => {
                        let rem;
                        if(hpColorInfo.length <= 1){
                            rem = 'HPBEV';
                        } else {
                            rem = 'HPBEV' + (index + 1);
                        }
                        bossCode.push({
                            boss_code : '042',
                            boss_remarks : rem,
                            pers_hp_code : rem,
                        });
                    });
                } else if(hpColorInfo.length != 0) {
                    hpColorInfo.forEach((element, index) => {
                        let rem;
                        if(hpColorInfo.length <= 1){
                            rem = 'HPBEV';
                        } else {
                            rem = 'HPBEV' + (index + 1);
                        }
                        bossCode.push({
                            boss_code : '042',
                            boss_remarks : rem,
                            pers_hp_code : rem,
                        });
                    });
                } else if(zeroHpColorInfo.length != 0){
                    zeroHpColorInfo.forEach((element, index) => {
                        let rem;
                        if(zeroHpColorInfo.length <= 1){
                            rem = 'HPBEV';
                        } else {
                            rem = 'HPBEV' + (index + 1);
                        }
                        bossCode.push({
                            boss_code : '042',
                            boss_remarks : rem,
                            pers_hp_code : rem,
                        });
                    });
                }
                
                // OLD, WITH PROBLEM WITH THE REGISTRATION
                // let rem = null;
                // cadRequestRevisionContent.hp.forEach((element, index) => {
                //     if(cadRequestRevisionContent.hp.length <= 1){
                //         rem = 'HPBEV';
                //     }else{
                //         rem = 'HPBEV' + (index+1);
                //     }
                //     bossCode.push({
                //         boss_code : '042',
                //         boss_remarks : rem,
                //         pers_hp_code : rem,
                //     });
                // });
            }
        }

        // SECTION : BOSS CODE : 201, 202, 852
        // NOTE    : 仕様検討ツール
        // if(cadRequestRevisionContent.shio_request){
        if(cadRequestRevisionContent.srs_shio && cadRequestRevisionContent.srs_shio.shio_selection !== '2' && cadRequestRevisionContent.shio_request){
            bossCode.push({
                    boss_code : '201',
                    boss_remarks : null,
                    pers_hp_code : null,
                },
                {
                    boss_code : '202',
                    boss_remarks : null,
                    pers_hp_code : null,
                },
                {
                    boss_code : '852',
                    boss_remarks : null,
                    pers_hp_code : null,
                });
        }

        // SECTION : BOSS CODE : B18, P65
        // NOTE    : Each selection has designated HRDID and should have remarks accordingly to illustration.
        if(cadRequestRevisionContent.web_documents){
            cadRequestRevisionContent.web_documents.forEach(element => {
                let tempWeb1 = null;
                let tempWeb2 = null;
                tempWeb1 = {
                    boss_code : 'B18',
                    boss_remarks : element.text,
                    pers_hp_code : 'B18-'+element.value,
                };
                tempWeb2 = {
                    boss_code : 'P65',
                    boss_remarks : element.text,
                    pers_hp_code : 'P65-'+element.value,
                };
                bossCode.push(tempWeb1);
                bossCode.push(tempWeb2);
            });
        }
        
        // SECTION : BOSS CODE : P33
        // NOTE    : Main boss_code
        if(cadRequestRevisionContent.house_presentation_int){
                bossCode.push({
                    boss_code : 'P33',
                    boss_remarks : null,
                    pers_hp_code : null,
                    // sched_for : '',
                });
        }

        // NOTE : If with P33 automatic with HPSP
        // if(withHPSP) {
        //     if(cadRequestRevisionContent.house_presentation_int){
        //         bossCode.push({
        //             boss_code : 'HPSP',
        //             boss_remarks : null,
        //             pers_hp_code : null,
        //             // sched_for : '',
        //         });
        //     }
        // }
                
        // SECTION : BOSS CODE : J53
        // NOTE    : If selected this button 展示場内装確認（打合せ用）INT, need to register this boss code
        if(cadRequestRevisionContent.jiban_plan == 1){
            bossCode.push({
                boss_code : 'J53',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }
        
        // SECTION : BOSS CODE : S98
        // NOTE    : Main boss_code (Need to record in databse of what kind of request)
        if(cadRequestRevisionContent.alvs != "" && cadRequestRevisionContent.alvs != null){
            bossCode.push({
                boss_code : 'S98',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }
                        
        // SECTION : BOSS CODE : S91, 975 -> INOTE KO DAW
        // NOTE    : Main boss_code (Need to record in databse of what kind of request)
        // cadRequestBasicInformation.house_type_category == 3 ? 'si_jiku_' : cadRequestBasicInformation.house_type_category == 2 ? 'si_waku_' : null,
        if(cadRequestRevisionContent.SR_OPTION_1 == 'あり'){
            bossCode.push({
                boss_code : '975',
                boss_remarks : null,
                pers_hp_code : null,
            },{
                boss_code : 'S91',
                boss_remarks : null,
                pers_hp_code : null,
            });

            // if(cadRequestBasicInformation.house_type_category == 3 || cadRequestBasicInformation.house_type_category == 2) {
            //     bossCode.push({
            //         boss_code : 'S91',
            //         boss_remarks : null,
            //         pers_hp_code : null,
            //     })
            // }
            
            // if(cadRequestBasicInformation.house_type_category == 2 && cadRequestRevisionContent.SR_OPTION_2) {
            //     bossCode.push({
            //         boss_code : 'S90',
            //         boss_remarks : null,
            //         pers_hp_code : null,
            //     })
            // }
            

        }
                        
        // SECTION : BOSS CODE : S89
        // NOTE    : Main boss_code (Need to record in databse of what kind of request)
        if(cadRequestRevisionContent.SR_OPTION_1 == 'あり' && cadRequestBasicInformation.house_type_category == 3){
            bossCode.push({
                boss_code : 'S89',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }
                        
        // SECTION : BOSS CODE : S90
        // NOTE    : Main boss_code (Need to record in databse of what kind of request)
        if(cadRequestRevisionContent.SR_OPTION_1 == 'あり' && cadRequestBasicInformation.house_type_category == 2 && cadRequestRevisionContent.SR_OPTION_2){
            bossCode.push({
                boss_code : 'S90',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }
                        
        // SECTION : BOSS CODE : 018
        // NOTE    : Main boss_code
        // if(cadRequestRevisionContent.pdr == '1'){
        //     bossCode.push({
        //         boss_code : '018',
        //         boss_remarks : null,
        //         pers_hp_code : null,
        //     },{
        //         boss_code : 'P28',
        //         boss_remarks : null,
        //         pers_hp_code : null,
        //     },{
        //         boss_code : '451',
        //         boss_remarks : null,
        //         pers_hp_code : null,
        //     }
        //     );
        // }
                        
        // SECTION : BOSS CODE : 017 / 018
        // NOTE    : Main boss_code
        if(cadRequestRevisionContent.ED_PDR_TITLE == '提案電気図面依頼'){
            // PDR
            bossCode.push(
                {
                    boss_code : '018',
                    boss_remarks : null,
                    pers_hp_code : null,
                },
                {
                    boss_code : 'P28',
                    boss_remarks : null,
                    pers_hp_code : null,
                },
                {
                    boss_code : '451',
                    boss_remarks : null,
                    pers_hp_code : null,
                }
            )

            // if(cadRequestRevisionContent.final_plan){
            //     bossCode.push(
            //         {
            //             boss_code : 'PG6',
            //             boss_remarks : null,
            //             pers_hp_code : null,
            //         },
            //     )
            // }
        }else if(cadRequestRevisionContent.ED_DENKI_PLAN_TITLE == "電気図面依頼" && cadRequestRevisionContent.ED_OPTION_1 == 'あり'){
            // DENKI
            bossCode.push(
                {
                    boss_code : '017',
                    boss_remarks : null,
                    pers_hp_code : null,
                },
                {
                    boss_code : 'P28',
                    boss_remarks : null,
                    pers_hp_code : null,
                },
                {
                    boss_code : '451',
                    boss_remarks : null,
                    pers_hp_code : null,
                }
            )

            if(cadRequestRevisionContent.final_plan){
                bossCode.push(
                    {
                        boss_code : 'PG6',
                        boss_remarks : null,
                        pers_hp_code : null,
                    },
                )
            }
        }
        // if(cadRequestRevisionContent.ED_OPTION_1 == 'あり' && cadRequestRevisionContent.ED_OPTION_2){
        //     bossCode.push({
        //         boss_code : '017',
        //         boss_remarks : null,
        //         pers_hp_code : null,
        //     },{
        //         boss_code : 'P28',
        //         boss_remarks : null,
        //         pers_hp_code : null,
        //     },{
        //         boss_code : '451',
        //         boss_remarks : null,
        //         pers_hp_code : null,
        //     }
        //     );
        // }
                        
        // SECTION : BOSS CODE : 832, S88
        // NOTE    : Main boss_code, Always package of 832
        if(cadRequestRevisionContent.stop == '1' || cadRequestRevisionContent.stop == '2'){
            bossCode.push({
                    boss_code : '832',
                    boss_remarks : null,
                    pers_hp_code : null,
                },{
                    // WALA SA EXCEL NA BINIBIGAY NI SIR CHAD DOC NAME
                    boss_code : 'S88',
                    boss_remarks : null,
                    pers_hp_code : null,
                }
            );
            if(cadRequestRevisionContent.stop_list){
                cadRequestRevisionContent.stop_list.filter((r) => {
                    if(r.isChecked ==1 ){
                        bossCode.push({
                            boss_code : '606',
                            boss_remarks : r.text,
                            pers_hp_code : r.text,
                        }
                        );
                    }
                })
            }

        }

        // SECTION : BOSS CODE : ZEH -> I-NOTE KO DAW
        // NOTE    : zeh_day==> if there is no circle in STOP
        //           zeh_with_stop_day==> if ZEH and STOP is selected in same time
        if(cadRequestRevisionContent.SR_OPTION_ZEH == 1){
            bossCode.push({
                boss_code : 'ZEH',
                boss_remarks : null,
                pers_hp_code : null,
                sched_for : cadRequestRevisionContent.stop == '1' ? 'zeh_with_stop_' : 'zeh_',
            });
        }

        if(cadRequestRevisionContent.SR_OPTION_GX == 1){
            bossCode.push({
                boss_code : 'GXS',
                boss_remarks : null,
                pers_hp_code : null,
                sched_for : cadRequestRevisionContent.stop == '1' ? 'zeh_with_stop_' : 'zeh_',
            });
        }

        // BOSS CODE : 754- 断面図/申請用立面図依頼
            // bossCode.push({
            //     boss_code : '754',
            //     boss_remarks : null,
            //     pers_hp_code : null,
            // });
        if(cadRequestRevisionContent.cross_section){
            bossCode.push({
                boss_code : 'PB8',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }

        if(cadRequestRevisionContent.elevation_section){
            bossCode.push({
                boss_code : 'PB9',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }

                        
        // SECTION : BOSS CODE : P79
        // NOTE    : If there is 003 boss code and select any of  〇　or  ① or ②, need to register this boss code.
        // let isBossCodeSelected003 = bossCode.some(value => codeP79.includes(value));
        // if((cadRequestRevisionContent.final_plan != '' || cadRequestRevisionContent.final_plan != null) && isBossCodeSelected003){
        //     bossCode.push({
        //         boss_code : 'P79',
        //         boss_remarks : null,
        //     },{
        //         boss_code : 'S88',
        //         boss_remarks : null,
        //     });
        // }
                        
        // SECTION : BOSS CODE : P79
        // NOTE    : If there is 003 boss code and select any of  〇　or  ① or ②, need to register this boss code.
        // if(cadRequestRevisionContent.express == '1'){
        //     bossCode.push({
        //         boss_code : '',
        //         boss_remarks : 'EXP',
        //         pers_hp_code : null,
        //     });
        // }
                        
        // SECTION : BOSS CODE : HPSP
        // NOTE    : If in one column of request contains any of boss code below, this boss code will be created automatically. 1 HRDID each column only.
        //           852 or 042 or 005 or any combination among these 3 boss code
        let isSpecial = bossCode.some(value => special.includes(value.boss_code));
        // console.log(isSpecial, 'esp', bossCode)
        if(isSpecial){
            bossCode.push({
                boss_code : 'HPSP',
                boss_remarks : null,
                pers_hp_code : null,
            });
            bossCode.push({
                boss_code : 'PD9',
                boss_remarks : null,
                pers_hp_code : null,
            });
        }
        // SECTION : BOSS CODE : 127
        // NOTE    : If boss code 003 or 201 present in the column, this boss code will be created automaticaly. 
        //           but if house type i-smileII(22), ismileII+(23), HUGme(3), and HUGme fam(29) => if there is boss code 201, it will automatically created.
        let isBossCodez = bossCode.some(value => code127.includes(value.boss_code)); // boss code for 003
        let isBossHouse = bossCode.some(value => code201.includes(value.boss_code)); // boss code for 201
        let code003NotHouseType = isBossCodez && ![3,22,23,29].includes(cadRequestBasicInformation.house_type_id); // 003 AND HOUSETYPE NOT EQUAL TO ismileII, ismileII+, HUGme and HUGme fam
        if ((code003NotHouseType || isBossHouse) && (isBossHouse || ![3, 22, 23, 29].includes(cadRequestBasicInformation.house_type_id))) {
            bossCode.push({
                boss_code: '127',
                boss_remarks: null,
                pers_hp_code: null,
            });
        }
        // if (cadRequestRevisionContent.shio_request){
        if (cadRequestRevisionContent.srs_shio && cadRequestRevisionContent.srs_shio.shio_selection == '2'){
            bossCode.push({
                boss_code: 'HPSP',
                boss_remarks: null,
                pers_hp_code: null,
            });
            bossCode.push({
                boss_code: 'PD9',
                boss_remarks: null,
                pers_hp_code: null,
            });
            bossCode.push({
                boss_code: '852',
                boss_remarks: null,
                pers_hp_code: null,
            });
        }

        // console.log(bossCode, 'boss')
        newBossRegister(bossCode)
        return bossCode;


    }

    export function json_remarks(basic_info, cad_request, data, boss){
        // console.log(boss, 'caaaaaaaaaaaaaad', cad_request, data);
        // console.log(basic_info,'basic infooooooo')
        // console.log(basic_info.expected_house_raising_date ? 'Already Kakouirai' : 'Before Kakouirai',)
        let attName = null;
        let alvsName = null;

        // ? GET ATTACHMENT FILE NAME - 357
        if(cad_request.attachments){
            cad_request.attachments.forEach(element => {
                if(element.att_column_name == "CAD依頼書結合ファイル"){
                    attName = element.filename;
                }
            });
        }

        // ? GET ALVS
        if(cad_request.alvs){
            if(cad_request.alvs == '1'){
                alvsName = '1-2-3'
            }else{
                let exploded = cad_request.alvs.split('');
                let temp = [];
                let num = ''

                exploded.forEach(element => {
                    if(element == "L"){
                        num = "1"
                    }else if(element == "V"){
                        num = "2"
                    }else if(element == "S"){
                        num = "3"
                    }
                    temp.push(num)
                });
                alvsName = temp.join('-')
            }
        }

        // ? GET ELEVATION AND CROSS SECTION
        let crossSection = [];
        if(cad_request.cross_section == '1'){
            crossSection.push('S');
        }
        if(cad_request.elevation_section == '1'){
            crossSection.push('E');
        }
        let sectionDrawing = crossSection.join('-')

        let remarks = {
            icad_plan: '',
            // ---alvs------
            request_type: cad_request.request_type,
            express: cad_request.express,
            attachment: attName,
            alvs: alvsName,
            zeh: cad_request.SR_OPTION_ZEH,
            gxs: cad_request.SR_OPTION_GX,
            sky_diagram: '',
            house_name: '',
            house_method: '',

            // -----SP-----: '',
            revision_type: '', // 
            gravity_type: '', //
            gravity: '', //
            electrical_drawing: '', //
            stop: cad_request.stop,
            final_plan: cad_request.final_plan,
            request_attach_from: '', //
            OPTION_1: cad_request.SR_OPTION_1,
            OPTION_2: cad_request.SR_OPTION_2,

            // -------denki before: '',
            date_requested: '', //
            time_requested: '', //
            // house_type: '', //
            denki_plan: '',
            shiyousho: '',
            spd: '',
            pdr: '',
            hrdProcess: cad_request.hrd_process,

            // ----shiyousho : '',
            stop_check: cad_request.stop,
            th_cad_request: '',
            change_contents: '',
            plan_status: '',

            // -----design_contract
            design_contract: cad_request.design_contract ? cad_request.design_contract : null,

            // -----sash
            sash_spec : '',
            spec : '',
            accessories : '',
            section_drawing : sectionDrawing,
        }

        var momentDate = moment.utc(cad_request.whole_date);

        // Adjust to Philippine time (UTC+8)
        momentDate = momentDate.utcOffset('+08:00');

        // Format the date in the desired format
        var formattedDate = momentDate.format('YYYY/MM/DD');
        var time = momentDate.format('HH:mm');

        let acceptedBy = null;

        if (cad_request.hrd_accepted_by) {
            const startIndex = cad_request.hrd_accepted_by.indexOf("(");
            const endIndex = cad_request.hrd_accepted_by.indexOf(")");

            if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
                acceptedBy = cad_request.hrd_accepted_by.substring(startIndex + 1, endIndex);
            }
        }

        let colorLayout = null;
        if (cad_request.site_layout) {
            if (cad_request.site_layout === '新規データN') {
                colorLayout = '001';
            } else if (cad_request.site_layout === '前回ベースP') {
                colorLayout = '002';
            } else if (cad_request.site_layout === '手入力M') {
                colorLayout = '003';
            }
        }

        let specs;

        if (cad_request.specs_irai && cad_request.specs_irai.sash_type) {
            switch (cad_request.specs_irai.sash_type) {
                case 'J':
                    specs = '001';
                    break;
                case 'F':
                    specs = '002';
                    break;
                case 'Y':
                    specs = '003';
                    break;
                default:
                    // Handle other cases if needed
                    break;
            }
        }

        let attachment = null;
        let ringisho = '0';
        let sekou = '0';
        if (cad_request.attachments) {
            const filteredData = cad_request.attachments.filter(item => item.att_column_name === "CAD依頼書結合ファイル");
            const ring = cad_request.attachments.filter(item => item.att_column_name === "営業本部回答票");
            const sek = cad_request.attachments.filter(item => item.att_column_name === "施工連絡表");

            if (filteredData.length > 0) {
                attachment = filteredData[0].filename;
            }
            if (ring.length > 0) {
                ringisho = '1';
            }
            if (sek.length > 0) {
                sekou = '1';
            }
        }

        let fire;
        if (basic_info.fire_protection) {
            switch (basic_info.fire_protection) {
                case '1':
                    fire = '0';
                    break;
                case '2':
                    fire = '1';
                    break;
                case '3':
                    fire = '2';
                    break;
                default:
                    // Handle other cases if needed
                    break;
            }
        }

        let icad = false;
        let pers_hp;
        if(boss){
            boss.filter((r) => {
                if(r.boss_code == '042'){
                    if(r.boss_remarks){
                        if(/\d/.test(r.boss_remarks)){
                            pers_hp = r.boss_remarks.replace(/\d/g, '')
                        }else{
                            pers_hp = r.boss_remarks
                        }
                    }
                }if(r.boss_code == 'P76') icad = true;
            })
        }
        console.log(icad, 'icad')
        let final_plan = '';
        if(cad_request.final_plan == '1'){
            final_plan = '003'
        }else if(cad_request.final_plan == '2'){
            final_plan = '001'
        }else if(cad_request.final_plan == '3'){
            final_plan = '002'
        }else{
            final_plan = null
        }
        
        let water = '';
        // NOTE - ORIGINAL CONDITION 11-26-25
        // if(basic_info.water_tight == '耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)'){
        //     water = 'standard';
        // }else if(basic_info.water_tight == '耐水害（浮上)'){
        //     water = 'float';
        // }

        // NOTE - ADDITIONAL CONDITION SSD25-1121783-2399 11-26-25
        if(basic_info.water_tight == '耐水害（ｽﾀﾝﾀﾞｰﾄﾞ)'){
            water = 'standard';
        }else if(basic_info.water_tight == '耐水害（浮上)'){
            water = 'float';
        }else if(basic_info.water_tight == '耐水害 (床下)'){
            water = 'underfloor'
        }
        

        let planner = data.plannerDetails;
        let salesman = data.salesmanDetails;
        let newRemarks = {
            "code_number" : cad_request.customer_code,
            "plan_number" : cad_request.revision_number,
            "user_name" : acceptedBy,
            "req_number" : "0",
            "date_requested" : formattedDate,
            "time_requested" : time,
            "tmp_contract_date" : basic_info.provisional_contract_date ? moment(basic_info.provisional_contract_date).format('YYYY/MM/DD') : "",
            "contract_date" : basic_info.contract_date ? moment(basic_info.contract_date).format('YYYY/MM/DD') : "",
            "request_type" : cad_request.request_type,
            // "plan_status" : basic_info.expected_house_raising_date != null ? 'Already Kakouirai' : 'Before Kakouirai',
            "plan_status" : basic_info.expected_house_raising_date ? (basic_info.kakouirai_reason == 1 ? 'Already Kakouirai' : 'Before Kakouirai') : 'Before Kakouirai',
            // "plan_status" : "0",
            "planner_code" : planner ? planner.EmployeeCode : "",
            "planner_name" : planner ? planner.EmployeeName : "",
            "planner_name_roma" : planner ? planner.EmployeeNameRoma : "",
            "planner_branch_code" : planner ? planner.ci != null ? planner.ci.ContractExhibitionCode : "" : "",
            "planner_branch_name" : planner ? planner.ci != null ? planner.ci.ContractExhibitionName : "" : "",
            "planner_branch_name_roma" : planner ? planner.ci != null ? planner.ci.ContractExhibitionNameRoma : "" : "",
            "salesman_code" : salesman ? salesman.EmployeeCode : "",
            "salesman_name" : salesman ? salesman.EmployeeName : "",
            "salesman_name_roma" : salesman ? salesman.EmployeeNameRoma : "",
            "salesman_branch_code" : salesman ? salesman.ci != null ? salesman.ci.ContractExhibitionCode : "" : "",
            "salesman_branch_name" : salesman ? salesman.ci != null ? salesman.ci.ContractExhibitionName : "" : "",
            "salesman_branch_code_roma" : salesman ? salesman.ci != null ? salesman.ci.ContractExhibitionNameRoma : "" : "",
            "house_type" : data.houseType ? data.houseType.house_type_code : "",
            // "house_type" : data.houseType ? data.houseType.id : "0",
            // "house_type" : "0",
            "building_spec" : "0",
            "prefecture_code" : basic_info.site_address_prefecture_code,
            "kanabakari" : data.kanabakari,
            "kaigan_kyori_flg" : "0",
            "seashore" : basic_info.distance_from_shore,
            "vsd" : basic_info.vertical_snow_cover,
            "wind_velocity" : basic_info.reference_wind_velocity,
            // "power_company_code" : data.power ? data.power.length > 1 ? '0' + data.power : '00' + data.power : "0",
            "power_company_code" :null,
            "dannetsu_area" : "0",
            "gousetsu_shiyou" : basic_info.heavy_snow,
            "remarks_code" : "0",
            "th_cad_request" : basic_info.sent_process_request_date ? '1' : '0',
            "th_cad_reason" : "0",
            "express" : cad_request.express,
            "change_contents" : data.changeContent,
            "carte_req" : "0",
            "carte_request_type" : "0",
            "trustee_agreement" : cad_request.design_contract,
            "mitsuke" : cad_request.calculation_basis,
            "color_layout" : colorLayout,
            "spec_sash_type" : specs,
            "color_perspective" : cad_request.color_pers,
            "duct_plan" : final_plan, // cad_request.SR_OPTION_2 == 'あり' ? '1' : '0',
            "dxf" : cad_request.dxf_data_request,
            "hp" : cad_request.house_presentation,
            "vent" : cad_request.ED_PDR_TITLE ? '1' : '0',
            "denki_plan" : cad_request.ED_OPTION_1 || cad_request.ED_OPTION_2 ? '1' : '0',
            "denki_plan_gravity" : cad_request.ED_DENKI_PLAN_GRAVITY, 
            "denki_stop" : cad_request.ED_ELECTRICAL_REQUEST,
            "shiyousho" : cad_request.shio_request,
            "stop_check" : cad_request.stop,
            "kozo_jizen" : cad_request.SR_OPTION_1 == 'あり' ? '1' : '0',
            "kozo_antei_E" : "0",
            "kozo_antei_S" : cad_request.SR_OPTION_S ? cad_request.SR_OPTION_S.substring(1) : '',
            "kozo_antei_W" : cad_request.SR_OPTION_W ? cad_request.SR_OPTION_W.substring(1) : '',
            "piping_plan" : "0",
            "fp" : final_plan,
            "attachment" : attachment,
            "cad_req_type" : "0",
            "customer_name" : "0",
            "cite_name" : "0",
            "alvs" : alvsName,
            "Cross" : sectionDrawing,
            "hp_int" : cad_request.house_presentation_int,
            "jiban_plot" : cad_request.jiban_plan,
            "Ekoushin" : cad_request.ED_OPTION_2 == 'あり' ? '1' : '0',
            "zeh" : cad_request.SR_OPTION_ZEH ? cad_request.SR_OPTION_ZEH.toString() : '',
            "gxs" : cad_request.SR_OPTION_GX ? cad_request.SR_OPTION_GX.toString() : '',
            "shadow" : "0",
            "sky_diagram" : "0",
            "ringisho" : ringisho,
            "sekou" : sekou,
            "option_req" : "0",
            "spd" : "0",
            "pdr" : cad_request.ED_PDR_TITLE ? '1' : '0',
            "hrdProcess" : cad_request.hrd_process,
            "tatemono_shiyou" : fire,
            "2bai_taishin" : basic_info.double_earthquake_resistance ? basic_info.double_earthquake_resistance : "",
            "base_isolation" : basic_info.seismic_isolation,
            "koubouka" : basic_info.high_fireproof_outer_wall,
            "aisuigai" :  water,
            "cad_receive" : "0",
            "house_name" : data.houseType.house_type_name_2,
            "house_method" : data.houseType.method,
            "boss_remarks" : "0",
            "xrs_version" : "0",
            "File_path" : "0",
            "Application_Request" : "0",
            "pers_hp_code" : "0",
            "pira_th" : "0",
            "icad_plan" : icad || cad_request.gravity === 0 || cad_request.isHrdCpn === 1 ? '1' : '0',
            // "icad_plan" : icad || (cad_request.gravity == '0' || (cad_request.revision_type === '8' && (cad_request.isHrdCpn === 1 || cad_request.isHrdCpn === null))
            //     || (cad_request.revision_type === '9' && (cad_request.isHrdCpn === 1 || cad_request.isHrdCpn === null))) ? '1' : '0',
            "cad_straight_process" : "1",
            "first_interview" : null,
        }

        // if(cad_request.specs_irai){
        //     remarks.sash_spec = cad_request.specs_irai.sash_type
        //     remarks.spec = cad_request.specs_irai.specs
        //     remarks.accessories = cad_request.specs_irai.accessories ? cad_request.specs_irai.accessories.map((r) => r.value).join(',') : null;
        // }

        return convertObjectToStrings(newRemarks);
    }

    export function bossDetails(){
        console.log('bossCode')
    }

    function convertObjectToStrings(obj) {
        // Check if the input is an object
        if (typeof obj === 'object' && obj !== null) {
          // Iterate through each property of the object
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                // Recursively convert nested objects and arrays
                obj[key] = convertObjectToStrings(obj[key]);
                }
            }
        } else {
          // If the value is null or undefined, convert it to an empty string; otherwise, convert to a string
            obj = obj === null || obj === undefined ? '' : String(obj);
        }
        return obj;
    }
